import { useBooking } from "~/context/BookingContext";

import "./CtaBanner.scss";

type Props = {
  title: string;
  body: string;
  action: string;
  /** "blue" is the wide promo panel; "dark" is the slimmer course-page banner. */
  tone?: "blue" | "dark";
};

export default function CtaBanner({
  title,
  body,
  action,
  tone = "blue",
}: Props) {
  const booking = useBooking();

  if (tone === "dark") {
    return (
      <section className="ss-section ss-container">
        <div className="ss-panel ss-panel--dark ss-cta-dark">
          <div>
            <h2 className="ss-cta-dark__title">{title}</h2>
            <p className="ss-cta-dark__body">{body}</p>
          </div>
          <button
            type="button"
            className="ss-btn ss-btn--accent ss-cta-dark__action"
            onClick={() => booking.open()}
          >
            {action}
          </button>
        </div>
      </section>
    );
  }

  return (
    <section className="ss-section ss-container">
      <div className="ss-panel ss-panel--blue ss-cta">
        <div className="ss-cta__blob" aria-hidden="true" />
        <div className="ss-cta__body">
          <h2 className="ss-cta__title">{title}</h2>
          <p className="ss-cta__lead">{body}</p>
          <button
            type="button"
            className="ss-btn ss-btn--invert"
            onClick={() => booking.open()}
          >
            {action}
          </button>
        </div>
      </div>
    </section>
  );
}
